import { render, staticRenderFns } from "./manage-notification.vue?vue&type=template&id=7d0f6d7f&scoped=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-notification.vue?vue&type=style&index=0&id=7d0f6d7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0f6d7f",
  null
  
)

export default component.exports